var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfirmIcon = function SvgConfirmIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 37,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#confirmIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5DC90A",
    d: "M18.999 34.155c-8.631 0-15.655-7.021-15.655-15.655S10.368 2.848 18.999 2.848s15.655 7.02 15.655 15.655-7.02 15.655-15.655 15.655zm0-30.662c-8.276 0-15.01 6.734-15.01 15.01s6.734 15.01 15.01 15.01 15.01-6.734 15.01-15.01-6.734-15.01-15.01-15.01"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#confirmIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5DC90A",
    d: "M17.423 35.649c-7.302 0-13.706-5.175-15.23-12.306a.24.24 0 0 1 .188-.287.24.24 0 0 1 .287.187c1.474 6.908 7.682 11.922 14.758 11.922a15 15 0 0 0 4.675-.739.243.243 0 0 1 .307.155.245.245 0 0 1-.155.306 15.5 15.5 0 0 1-4.827.762zm10.263-3.943a.244.244 0 0 1-.165-.423 15.12 15.12 0 0 0 4.986-11.208v-.062c0-.132.106-.242.239-.245a.24.24 0 0 1 .242.239v.064c0 4.401-1.875 8.618-5.147 11.567a.24.24 0 0 1-.161.062zM2.094 20.333c-.133 0-.242-.094-.242-.226v-.032c0-4.389 1.868-8.6 5.123-11.545.1-.09.252-.08.342.016.09.1.081.252-.016.342A15.11 15.11 0 0 0 2.34 20.075c0 .132-.11.258-.242.258zm30.316-3.266a.24.24 0 0 1-.235-.19c-1.488-6.892-7.69-11.893-14.749-11.893-1.61 0-3.191.252-4.704.749a.244.244 0 0 1-.307-.155.245.245 0 0 1 .155-.307 15.5 15.5 0 0 1 4.856-.771c7.286 0 13.69 5.162 15.223 12.274a.242.242 0 0 1-.236.293z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5DC90A",
    d: "m25.158 11.867-9.324 9.456-3.693-3.743-2.567 2.602 6.26 6.346 11.891-12.059z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "confirmIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h37v37H.5z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "confirmIcon_svg__b",
    width: 34.537,
    height: 34.549,
    x: 0.152,
    y: 2.8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6_5729",
    stdDeviation: 0.85
  })))));
};
export default SvgConfirmIcon;